import React from "react";
import { useDispatch } from "react-redux";
import { lighten } from '@mui/material/styles';
import { Grid, Box, Typography } from "@mui/material";
import { addContainerTypeFilterValue } from "../../data/filter";

export default function ContainerCounts({
  containers,
  containerTypes,
  loading,
  activeFilters = [],
}) {
  const dispatch = useDispatch();
  const totalCount = containers.length;

  const loadedCount = containers.filter((container) =>
    loading ? !!container.loadedDate : !!container.unloadedDate
  ).length;

  const percentage = totalCount > 0 ? (loadedCount / totalCount) * 100 : 0;

  const countContainersbyType = (containerType) => {
    return containers.filter(
      (container) => container.containerType["@id"] === containerType["@id"]
    );
  };

  const title = loading ? "Load" : "Unload";
  const totalTEU = containers.reduce(
    (acc, container) => acc + (container.containerType.teu || 0),
    0
  );

  return (
    <Grid className="terminal-container-load-wrapper" item>
      {containers?.length > 0 && containerTypes?.length > 0 ? (
        <>
          <Box sx={{ 
            position: "relative", 
            width: "100%", 
            mb: '2px', 
            bgcolor: lighten("#1976D2", 0.9)
          }}>
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0,
                width: `${percentage}%`,
                bgcolor: lighten("#1976D2", 0.5),
                borderRadius: 1,
              }}
            />
            <Box
              sx={{
                position: "relative",
                px: 1,
                py: 0.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {`${title} ${totalTEU} TEU`}
              </Typography>
            </Box>
          </Box>
          <Grid className="terminal-container-load-content-wrapper" item>
            {containerTypes.map((containerType) => {
              const count = countContainersbyType(containerType).length;
              if (count === 0) return null;

              const id = containerType["@id"];
              const isActive = activeFilters.includes(id);

              const handleClick = () => {
                if (!isActive) {
                  dispatch(addContainerTypeFilterValue(id));
                }
              };

              return (
                <Grid 
                  width="100%" 
                  key={containerType["@id"]}
                  onClick={handleClick}
                >
                  <Grid
                    className="terminal-container-load-content-title"
                    item
                    xs
                  >
                    {containerType.abbreviation ?? containerType.name}
                  </Grid>
                  <Grid className="terminal-container-load-content" item xs>
                    {count}
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </>
      ) : ""}
    </Grid>
  );
}